//
import {
  CAJA_ESTADOCUENTA,
  CAJA_ESTADOCUENTA_SUCCESS,
  CAJA_ESTADOCUENTA_FAIL,
  CAJA_GET_DESCUENTOSCATALOGO,
  CAJA_GET_DESCUENTOSCATALOGO_SUCCESS,
  CAJA_GET_DESCUENTOSCATALOGO_FAIL,
  CAJA_GET_DESCUENTOSXIDCUENTA,
  CAJA_GET_DESCUENTOSXIDCUENTA_SUCCESS,
  CAJA_GET_DESCUENTOSXIDCUENTA_FAIL,
  CAJA_GET_GSEQUIVALENTES,
  CAJA_GET_GSEQUIVALENTES_SUCCESS,
  CAJA_GET_GSEQUIVALENTES_FAIL,
  CAJA_GET_FORMASPAGOSAT,
  CAJA_GET_FORMASPAGOSAT_SUCCESS,
  CAJA_GET_FORMASPAGOSAT_FAIL,
  CAJA_GET_USOSCFDI40,
  CAJA_GET_USOSCFDI40_SUCCESS,
  CAJA_GET_USOSCFDI40_FAIL,
  CAJA_POST_ABONOACUENTA,
  CAJA_POST_ABONOACUENTA_SUCCESS,
  CAJA_POST_ABONOACUENTA_FAIL,
  CAJA_GET_RECIBOPAGO,
  CAJA_GET_RECIBOPAGO_SUCCESS,
  CAJA_GET_RECIBOPAGO_FAIL,
  CAJA_POST_ENVIORECIBO,
  CAJA_POST_ENVIORECIBO_SUCCESS,
  CAJA_POST_ENVIORECIBO_FAIL,
  CAJA_ALUMNOS,
  CAJA_ALUMNOS_SUCCESS,
  CAJA_ALUMNOS_FAIL,
  CAJA_LOGOUT,
  CAJA_GET_SERVICIOS,
  CAJA_GET_SERVICIOS_SUCCESS,
  CAJA_GET_SERVICIOS_FAIL,
  CAJA_GET_ULTIMOCARGO,
  CAJA_GET_ULTIMOCARGO_SUCCESS,
  CAJA_GET_ULTIMOCARGO_FAIL,
  CAJA_SET_IDALUMNOSELECTED,
  CAJA_SET_OALUMNOSELECTED,
  CAJA_DEL_IDRELACIONDESCUENTOCARGO,
  CAJA_DEL_IDRELACIONDESCUENTOCARGO_SUCCESS,
  CAJA_DEL_IDRELACIONDESCUENTOCARGO_FAIL,
  CAJA_POST_ADDCARGO,
  CAJA_POST_ADDCARGO_SUCCESS,
  CAJA_POST_ADDCARGO_FAIL,
  CAJA_DEL_OCARGO,
  CAJA_DEL_OCARGO_SUCCESS,
  CAJA_DEL_OCARGO_FAIL,
  CAJA_GET_CONCEPTOSGASTO,
  CAJA_GET_CONCEPTOSGASTO_SUCCESS,
  CAJA_GET_CONCEPTOSGASTO_FAIL,
  CAJA_POST_ADDGASTO,
  CAJA_POST_ADDGASTO_SUCCESS,
  CAJA_POST_ADDGASTO_FAIL,
  CAJA_SET_MESSAGE_SUCCESS,
  CAJA_UNSET_MESSAGE_SUCCESS,
  CAJA_LINKPAGO,
  CAJA_LINKPAGO_SUCCESS,
  CAJA_LINKPAGO_FAIL,
  CAJA_LINKPAGO_MASIVO,
  CAJA_LINKPAGO_MASIVO_SUCCESS,
  CAJA_LINKPAGO_MASIVO_FAIL,
  CAJA_GET_GASTO,
  CAJA_GET_GASTO_SUCCESS,
  CAJA_GET_GASTO_FAIL,
  CAJA_GET_GASTOS,
  CAJA_GET_GASTOS_SUCCESS,
  CAJA_GET_GASTOS_FAIL,
  CAJA_DEL_GASTO,
  CAJA_DEL_GASTO_SUCCESS,
  CAJA_DEL_GASTO_FAIL,
} from "./actionTypes"

export const getCajaGasto = jsonparameters => ({
  type: CAJA_GET_GASTO,
  payload: { jsonparameters },
})
export const getCajaGastoSuccess = data => ({
  type: CAJA_GET_GASTO_SUCCESS,
  payload: { data },
})
export const getCajaGastoFail = error => ({
  type: CAJA_GET_GASTO_FAIL,
  payload: error,
})
export const delCajaGasto = jsonparameters => ({
  type: CAJA_DEL_GASTO,
  payload: { jsonparameters },
})
export const delCajaGastoSuccess = data => ({
  type: CAJA_DEL_GASTO_SUCCESS,
  payload: { data },
})
export const delCajaGastoFail = error => ({
  type: CAJA_DEL_GASTO_FAIL,
  payload: error,
})
export const getCajaGastos = jsonparameters => ({
  type: CAJA_GET_GASTOS,
  payload: { jsonparameters },
})
export const getCajaGastosSuccess = data => ({
  type: CAJA_GET_GASTOS_SUCCESS,
  payload: { data },
})
export const getCajaGastosFail = error => ({
  type: CAJA_GET_GASTOS_FAIL,
  payload: error,
})

export const postCajaLinkPago = jsonparameters => ({
  type: CAJA_LINKPAGO,
  payload: { jsonparameters },
})
export const postCajaLinkPagoSuccess = data => ({
  type: CAJA_LINKPAGO_SUCCESS,
  payload: { data },
})
export const postCajaLinkPagoFail = error => ({
  type: CAJA_LINKPAGO_FAIL,
  payload: error,
})

export const postCajaLinkPagoMasivo = jsonparameters => ({
  type: CAJA_LINKPAGO_MASIVO,
  payload: { jsonparameters },
})
export const postCajaLinkPagoMasivoSuccess = data => ({
  type: CAJA_LINKPAGO_MASIVO_SUCCESS,
  payload: { data },
})
export const postCajaLinkPagoMasivoFail = error => ({
  type: CAJA_LINKPAGO_MASIVO_FAIL,
  payload: error,
})

export const setCajaMensajeExito = mensajeExitoso => ({
  type: CAJA_SET_MESSAGE_SUCCESS,
  payload: { mensajeExitoso },
})

export const unsetCajaMensajeExito = () => ({
  type: CAJA_UNSET_MESSAGE_SUCCESS,
})

export const getCajaConceptosGasto = jsonparameters => ({
  type: CAJA_GET_CONCEPTOSGASTO,
  payload: { jsonparameters },
})
export const getCajaConceptosGastoSuccess = data => ({
  type: CAJA_GET_CONCEPTOSGASTO_SUCCESS,
  payload: { data },
})
export const getCajaConceptosGastoFail = error => ({
  type: CAJA_GET_CONCEPTOSGASTO_FAIL,
  payload: error,
})

export const postCajaAddCargo = jsonparameters => ({
  type: CAJA_POST_ADDCARGO,
  payload: { jsonparameters },
})
export const postCajaAddCargoSuccess = id_Relacion_Cuenta_Cargo => ({
  type: CAJA_POST_ADDCARGO_SUCCESS,
  payload: { id_Relacion_Cuenta_Cargo },
})
export const postCajaAddCargoFail = error => ({
  type: CAJA_POST_ADDCARGO_FAIL,
  payload: error,
})

export const postCajaAddGasto = jsonparameters => ({
  type: CAJA_POST_ADDGASTO,
  payload: { jsonparameters },
})
export const postCajaAddGastoSuccess = data => ({
  type: CAJA_POST_ADDGASTO_SUCCESS,
  payload: { data },
})
export const postCajaAddGastoFail = error => ({
  type: CAJA_POST_ADDGASTO_FAIL,
  payload: error,
})

export const delCajaDeloCargo = jsonparameters => ({
  type: CAJA_DEL_OCARGO,
  payload: { jsonparameters },
})
export const delCajaDeloCargoSuccess = data => ({
  type: CAJA_DEL_OCARGO_SUCCESS,
  payload: { data },
})
export const delCajaDeloCargoFail = error => ({
  type: CAJA_DEL_OCARGO_FAIL,
  payload: error,
})

export const delCajaDelIdRelacionDescuentoCargo = jsonparameters => ({
  type: CAJA_DEL_IDRELACIONDESCUENTOCARGO,
  payload: { jsonparameters },
})
export const delCajaDelIdRelacionDescuentoCargoSuccess = data => ({
  type: CAJA_DEL_IDRELACIONDESCUENTOCARGO_SUCCESS,
  payload: { data },
})
export const delCajaDelIdRelacionDescuentoCargoFail = error => ({
  type: CAJA_DEL_IDRELACIONDESCUENTOCARGO_FAIL,
  payload: error,
})

export const getCajaUltimoCargo = jsonparameters => ({
  type: CAJA_GET_ULTIMOCARGO,
  payload: { jsonparameters },
})
export const getCajaUltimoCargoSuccess = data => ({
  type: CAJA_GET_ULTIMOCARGO_SUCCESS,
  payload: { data },
})
export const getCajaUltimoCargoFail = error => ({
  type: CAJA_GET_ULTIMOCARGO_FAIL,
  payload: error,
})

export const getCajaAlumnos = jsonparameters => ({
  type: CAJA_ALUMNOS,
  payload: { jsonparameters },
})
export const getCajaAlumnosSuccess = data => ({
  type: CAJA_ALUMNOS_SUCCESS,
  payload: { data },
})
export const getCajaAlumnosFail = error => ({
  type: CAJA_ALUMNOS_FAIL,
  payload: error,
})

export const getCajaReciboPago = jsonparameters => ({
  type: CAJA_GET_RECIBOPAGO,
  payload: { jsonparameters },
})
export const getCajaReciboPagoSuccess = data => ({
  type: CAJA_GET_RECIBOPAGO_SUCCESS,
  payload: { data },
})
export const getCajaReciboPagoFail = error => ({
  type: CAJA_GET_RECIBOPAGO_FAIL,
  payload: error,
})

export const postCajaAbonoaCuenta = jsonparameters => ({
  type: CAJA_POST_ABONOACUENTA,
  payload: { jsonparameters },
})
export const postCajaAbonoaCuentaSuccess = id_Recibo_Pago => ({
  type: CAJA_POST_ABONOACUENTA_SUCCESS,
  payload: { id_Recibo_Pago },
})
export const postCajaAbonoaCuentaFail = error => ({
  type: CAJA_POST_ABONOACUENTA_FAIL,
  payload: error,
})

export const postCajaEnvioRecibo = jsonparameters => ({
  type: CAJA_POST_ENVIORECIBO,
  payload: { jsonparameters },
})
export const postCajaEnvioReciboSuccess = mensajeExitoso => ({
  type: CAJA_POST_ENVIORECIBO_SUCCESS,
  payload: { mensajeExitoso },
})
export const postCajaEnvioReciboFail = error => ({
  type: CAJA_POST_ENVIORECIBO_FAIL,
  payload: error,
})

export const getCajaEstadoCuenta = jsonparameters => ({
  type: CAJA_ESTADOCUENTA,
  payload: { jsonparameters },
})
export const getCajaEstadoCuentaSuccess = edoCuenta => ({
  type: CAJA_ESTADOCUENTA_SUCCESS,
  payload: { edoCuenta },
})
export const getCajaEstadoCuentaFail = error => ({
  type: CAJA_ESTADOCUENTA_FAIL,
  payload: error,
})

export const getCajaDescuentosCatalogo = jsonparameters => ({
  type: CAJA_GET_DESCUENTOSCATALOGO,
  payload: { jsonparameters },
})
export const getCajaDescuentosCatalogoSuccess = descuentosCatalogo => ({
  type: CAJA_GET_DESCUENTOSCATALOGO_SUCCESS,
  payload: { descuentosCatalogo },
})
export const getCajaDescuentosCatalogoFail = error => ({
  type: CAJA_GET_DESCUENTOSCATALOGO_FAIL,
  payload: error,
})
export const getCajaDescuentosxidCuenta = jsonparameters => ({
  type: CAJA_GET_DESCUENTOSXIDCUENTA,
  payload: { jsonparameters },
})
export const getCajaDescuentosxidCuentaSuccess = descuentosxidCuenta => ({
  type: CAJA_GET_DESCUENTOSXIDCUENTA_SUCCESS,
  payload: { descuentosxidCuenta },
})
export const getCajaDescuentosxidCuentaFail = error => ({
  type: CAJA_GET_DESCUENTOSXIDCUENTA_FAIL,
  payload: error,
})

export const getCajaGSEquivalentes = jsonparameters => ({
  type: CAJA_GET_GSEQUIVALENTES,
  payload: { jsonparameters },
})
export const getCajaGSEquivalentesSuccess = data => ({
  type: CAJA_GET_GSEQUIVALENTES_SUCCESS,
  payload: { data },
})
export const getCajaGSEquivalentesFail = error => ({
  type: CAJA_GET_GSEQUIVALENTES_FAIL,
  payload: error,
})

export const getCajaFormasPagoSAT = jsonparameters => ({
  type: CAJA_GET_FORMASPAGOSAT,
  payload: { jsonparameters },
})
export const getCajaFormasPagoSATSuccess = data => ({
  type: CAJA_GET_FORMASPAGOSAT_SUCCESS,
  payload: { data },
})
export const getCajaFormasPagoSATFail = error => ({
  type: CAJA_GET_FORMASPAGOSAT_FAIL,
  payload: error,
})

export const getCajaUsosCFDI40 = jsonparameters => ({
  type: CAJA_GET_USOSCFDI40,
  payload: { jsonparameters },
})
export const getCajaUsosCFDI40Success = data => ({
  type: CAJA_GET_USOSCFDI40_SUCCESS,
  payload: { data },
})
export const getCajaUsosCFDI40Fail = error => ({
  type: CAJA_GET_USOSCFDI40_FAIL,
  payload: error,
})

export const getCajaServicios = jsonparameters => ({
  type: CAJA_GET_SERVICIOS,
  payload: { jsonparameters },
})
export const getCajaServiciosSuccess = data => ({
  type: CAJA_GET_SERVICIOS_SUCCESS,
  payload: { data },
})
export const getCajaServiciosFail = error => ({
  type: CAJA_GET_SERVICIOS_FAIL,
  payload: error,
})

export const SetCajaIdAlumnoSelected = id_Alumno => ({
  type: CAJA_SET_IDALUMNOSELECTED,
  payload: { oAlumno },
})

export const SetCajaoAlumnoSelected = oAlumno => ({
  type: CAJA_SET_OALUMNOSELECTED,
  payload: { oAlumno },
})

export const SetCajaLogout = () => {
  console.log("export const SetCajaLogout")
  return {
    type: CAJA_LOGOUT,
  }
}
